/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_University_SkipInputs */

const en_onboarding_university_skip = /** @type {(inputs: Onboarding_University_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not applicable`)
};

const es_onboarding_university_skip = /** @type {(inputs: Onboarding_University_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No aplica`)
};

/**
* | output |
* | --- |
* | "Not applicable" |
*
* @param {Onboarding_University_SkipInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_university_skip = /** @type {((inputs?: Onboarding_University_SkipInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_University_SkipInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_university_skip(inputs)
	return en_onboarding_university_skip(inputs)
});